import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { shortenAddress } from "../formatters";
import type { GrantItemContentProps } from "../types";
import { GrantExpiryBadge } from "./GrantExpiryBadge";
import { StatusBadge } from "./StatusBadge";
import { GrantDetailsGrid } from "./GrantDetailsGrid";
import { GrantErrorDetails } from "./GrantErrorDetails";
export function GrantItemContent(t0) {
  const $ = _c(39);
  const {
    contract,
    details,
    errorDetails,
    status,
    validFrom,
    validTo,
    actions
  } = t0;
  let t1;
  if ($[0] !== contract.address || $[1] !== contract.name) {
    t1 = contract.name ?? shortenAddress(contract.address);
    $[0] = contract.address;
    $[1] = contract.name;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const name = t1;
  let t2;
  if ($[3] !== contract.imageUrl || $[4] !== name) {
    t2 = <div className="tw-relative tw-h-16 tw-w-16 tw-flex-shrink-0 tw-overflow-hidden tw-rounded-lg tw-bg-iron-800">{contract.imageUrl ? <Image src={contract.imageUrl} alt={name} fill={true} sizes="64px" className="tw-h-full tw-w-full tw-object-cover" /> : <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-text-xs tw-font-semibold tw-uppercase tw-text-iron-400">NFT</div>}</div>;
    $[3] = contract.imageUrl;
    $[4] = name;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== name) {
    t3 = <p className="tw-m-0 tw-text-base tw-font-semibold tw-text-iron-50">{name}</p>;
    $[6] = name;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== contract.address) {
    t4 = shortenAddress(contract.address);
    $[8] = contract.address;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <p className="tw-m-0 tw-text-xs tw-text-iron-500">{t4}</p>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t5) {
    t6 = <div className="tw-flex tw-flex-col tw-gap-0.5">{t3}{t5}</div>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t2 || $[16] !== t6) {
    t7 = <div className="tw-flex tw-items-center tw-gap-3">{t2}{t6}</div>;
    $[15] = t2;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = typeof validTo === "number" ? validTo : null;
  let t9;
  if ($[18] !== t8) {
    t9 = <GrantExpiryBadge validUntil={t8} />;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== status || $[21] !== validFrom || $[22] !== validTo) {
    t10 = <StatusBadge status={status} validFrom={validFrom} validTo={validTo} />;
    $[20] = status;
    $[21] = validFrom;
    $[22] = validTo;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== actions || $[25] !== t10 || $[26] !== t9) {
    t11 = <div className="tw-flex tw-items-center tw-gap-3">{t9}{t10}{actions}</div>;
    $[24] = actions;
    $[25] = t10;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11 || $[29] !== t7) {
    t12 = <header className="tw-flex tw-flex-col md:tw-flex-row tw-items-start tw-justify-between tw-gap-4">{t7}{t11}</header>;
    $[28] = t11;
    $[29] = t7;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== details) {
    t13 = <GrantDetailsGrid details={details} />;
    $[31] = details;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== errorDetails) {
    t14 = errorDetails ? <GrantErrorDetails message={errorDetails} /> : null;
    $[33] = errorDetails;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t12 || $[36] !== t13 || $[37] !== t14) {
    t15 = <div className="tw-flex tw-flex-col tw-gap-4">{t12}{t13}{t14}</div>;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  return t15;
}